var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailStarFill = function SvgMailStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 13.84a5.4 5.4 0 0 0-7.48 6.26H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9zm-8.946-2.125-5.77-4.9-1.166 1.371 6.948 5.9 6.823-5.904L17.71 6.82zm6.696 9.06-2.38 1.251.454-2.65-1.926-1.878 2.661-.387 1.191-2.41 1.19 2.411 2.662.387-1.926 1.877.455 2.651z"
  })));
};
export default SvgMailStarFill;